import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,_vm._b({attrs:{"label":_vm.$t('First name'),"outlined":"","hide-details":"auto"},model:{value:(_vm.given_name),callback:function ($$v) {_vm.given_name=$$v},expression:"given_name"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }